import React, { useEffect, useRef, useState } from "react";

interface Placeholder {
  name: string;
  string: string;
}

interface PlaceholderInputProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  emailTemplateValues: Placeholder[] | any;
}

const PlaceholderInput: React.FC<PlaceholderInputProps> = ({
  value,
  onChange,
  placeholder,
  emailTemplateValues,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
if (e.key === "/") {
  setTimeout(() => {
    if (!inputRef.current) return;

    const inputRect = inputRef.current.getBoundingClientRect();

    setDropdownPos({
      top: inputRect.top + window.scrollY - 210, // 200 dropdown height + 10 margin
      left: inputRect.left + window.scrollX,
    });

    setShowDropdown(true);
    setSearchTerm("");
  }, 10);
}


  };

  const insertPlaceholder = (placeholder: string) => {
    if (!inputRef.current) return;
    const el = inputRef.current;
    const cursorPos = el.selectionStart ?? value.length;

    // Remove '/' just before cursor if it exists
    let newValue = value;
    if (cursorPos > 0 && value[cursorPos - 1] === "/") {
      newValue = value.slice(0, cursorPos - 1) + value.slice(cursorPos);
    }

    const finalValue =
      newValue.slice(0, cursorPos - 1) + `{{object.${placeholder}}}` + newValue.slice(cursorPos);
    onChange(finalValue);
    setShowDropdown(false);

    // Set cursor after inserted text
    setTimeout(() => {
    //   el.focus();
      const newPos = cursorPos - 1 + `{{object.${placeholder}}}`.length;
      el.setSelectionRange(newPos, newPos);
    }, 0);
  };

  const filtered = emailTemplateValues.filter((p:any) =>
    p.string.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node) &&
        !wrapperRef.current?.contains(e.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || "Template Subject"}
        // className="h-[38px] w-full px-3 py-2 border border-gray-300 rounded-md"
          className="h-[38px] w-full text-sm px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-0 placeholder:text-sm"
      />

      {showDropdown && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: dropdownPos.top,
            left: dropdownPos.left,
            backgroundColor: "white",
            // border: "1px solid #ccc",
            borderRadius: 4,
            // boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
            minWidth: 200,
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 10000,
          }}
        >
          <input
            type="text"
            autoFocus
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search placeholders..."
            style={{
              padding: "8px",
              width: "100%",
              boxSizing: "border-box",
              borderBottom: "1px solid #eee",
            }}
          />
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {filtered.length > 0 ? (
              filtered.map((item:any) => (
                <li
                  key={item.name}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    insertPlaceholder(item.name);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #f3f3f3",
                  }}
                >
                  {item.string} ({item.name})
                </li>
              ))
            ) : (
              <li
                style={{ padding: "8px", color: "#888", fontStyle: "italic" }}
              >
                No matches
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PlaceholderInput;
